import * as yup from 'yup'

import constants from 'constants/index'

const { PLATFORMS } = constants.regulations

const generalSchema = yup.object().shape({
  title: yup.string().required(),
  description: yup.string().required(),
  platform: yup.string().oneOf(Object.values(PLATFORMS)).required(),
})

export default generalSchema
